import { IconProps } from "../../utils/global-types/global-types";

const TicketDetailsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={className || "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 15.5 2h-11ZM6 6a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H6Zm0 3a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H6Zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1H6Z"
        clipRule="evenodd"
      />
      <circle cx="15.5" cy="15.5" r="3.5" fill="currentColor" opacity="0.3" />
      <path
        fill="currentColor"
        d="M15.5 13.75a.5.5 0 0 1 .5.5V15h.75a.5.5 0 0 1 0 1H16v.75a.5.5 0 0 1-1 0V16h-.75a.5.5 0 0 1 0-1H15v-.75a.5.5 0 0 1 .5-.5Z"
      />
    </svg>
  );
};

export default TicketDetailsIcon;
